import React, { useCallback, useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Florencia',
  city: 'Córdoba'
}, {
  name: 'Valentina',
  city: 'Rosario'
}, {
  name: 'Camila',
  city: 'Mendoza'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Julieta',
  city: 'Mar del Plata'
}, {
  name: 'Agustina',
  city: 'La Plata'
}, {
  name: 'Daniela',
  city: 'Salta'
}, {
  name: 'Diego',
  city: 'San Juan'
}, {
  name: 'Carolina',
  city: 'Santa Fe'
}, {
  name: 'Roberto',
  city: 'Neuquén'
}, {
  name: 'Andrea',
  city: 'Bahía Blanca'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  const showNextPopup = useCallback(() => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  }, []);
  useEffect(() => {
    const initialTimeout = setTimeout(showNextPopup, 5000);
    return () => clearTimeout(initialTimeout);
  }, [showNextPopup]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto cursor-pointer animate-slide-up" onClick={() => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  })} data-id="element-208">
      <div className="bg-yellow-950 rounded-lg shadow-lg border border-yellow-800/50 px-4 py-3 flex items-center gap-3 relative" data-id="element-209">
        <span className="text-2xl flex-shrink-0" data-id="element-210">🏆</span>
        <p className="text-sm text-yellow-100" data-id="element-211">
          <strong className="text-yellow-400" data-id="element-212">{currentPurchase.name}</strong> de{' '}
          {currentPurchase.city} compró el{' '}
          <strong className="text-yellow-400" data-id="element-213">Pack Completo</strong>{' '}
          <span className="text-yellow-500" data-id="element-214">⭐</span>
        </p>
        <button onClick={e => {
        e.stopPropagation();
        setIsVisible(false);
      }} className="absolute -top-2 -right-2 bg-yellow-900 border border-yellow-800 rounded-full p-0.5 text-yellow-500 hover:text-yellow-300" data-id="element-215">
          <XIcon className="w-3 h-3" data-id="element-216" />
        </button>
      </div>
    </div>;
}